var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linka)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    fillRule: "evenodd",
    d: "M11.135 7.815a1.746 1.746 0 1 1 2.47 2.469l-.652.651a.643.643 0 0 0 .909.91l.652-.652a3.032 3.032 0 0 0-4.288-4.287l-.651.651a.643.643 0 1 0 .909.91l.651-.652Zm-2.678 2.678a.643.643 0 1 0-.91-.909l-.651.652a3.032 3.032 0 1 0 4.287 4.287l.652-.651a.643.643 0 0 0-.91-.91l-.65.652a1.746 1.746 0 1 1-2.47-2.469l.652-.652Zm3.716-1.247a.643.643 0 0 1 0 .91l-2.027 2.026a.643.643 0 1 1-.91-.909l2.028-2.027a.643.643 0 0 1 .909 0Zm5.629 4.022a.643.643 0 0 1 0 .91l-1.363 1.362 1.363 1.362a.643.643 0 1 1-.91.91l-1.362-1.363-1.362 1.362a.643.643 0 1 1-.91-.909l1.363-1.362-1.363-1.363a.643.643 0 0 1 .91-.909l1.362 1.363 1.363-1.363a.643.643 0 0 1 .909 0Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linka"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "linkb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCreated);
export default __webpack_public_path__ + "static/media/link-created.8806fdd0ff74ce11033a51dba2555027.svg";
export { ForwardRef as ReactComponent };